export const comments_4322235 = {"data":{"data":[],"links":{}}}